import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

export function PageContent({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col gap-8 px-8 py-8', className)}>
      {children}
    </div>
  );
}
